export const BANNER_TEST_ID = 'banner';
export const CLOSED_BUSINESS_BANNER_TEST_ID = 'closed-business-banner';
export const EXPIRED_LINK_BANNER_TEST_ID = 'expired-link-banner';
